import React from "react";
import { Document, Page, View, Text, StyleSheet } from "@react-pdf/renderer";
import { LogoBlock } from "../components/LogoBlock/LogoBlock";
import { reportThemes as themes } from "../themes";
import { BackgroundBlocks } from "../components/BackgroundBlocks/BackgroundBlocks";
import { FooterBlock } from "../components/FooterBlock/FooterBlock";
import { Body } from "../components/Body/Body";
import {
  BodyHeader,
  BodyHeaderItem,
} from "../components/BodyHeader/BodyHeader";
import { Table } from "../components/Table/Table";
import generalStyle from "../styles";
import { decimalPlaces } from "../../../../helpers/mealsHelper";

const headersTable1 = [
  {
    value: "Date Range",
    width: "31%",
    textAlign: "left",
  },
  {
    value: "Complete",
    width: "17%",
    textAlign: "right",
  },
  {
    value: "Sick Day",
    width: "23%",
    textAlign: "right",
  },
  {
    value: "Study Drug Daily AVG*",
    width: "29%",
    textAlign: "right",
  },
];

const headersTable2 = [
  {
    value: "Date/time",
    width: "31%",
    textAlign: "left",
  },
  {
    value: "Complete",
    width: "17%",
    textAlign: "right",
  },
  {
    value: "Sick day",
    width: "23%",
    textAlign: "right",
  },
  {
    value: "Study Drug",
    width: "29%",
    textAlign: "right",
  },
];

const reportStyle = StyleSheet.create({
  note: {
    ...generalStyle.bold,
    fontSize: 8,
    marginTop: 7,
  },
  text: {
    fontSize: 10,
  },
  defaultMargin: {
    marginTop: 10,
  },
  signature: {
    marginLeft: 2,
  },
  signtureTitle: {
    marginLeft: 5,
  },
  weekSentece: {
    marginLeft: 4,
  },
});

const ITEMS_PER_PAGE = 14;

const StudyDrugIntakeReport = (data, { theme = "rarify" }) => {
  const {
    participantID,
    generatedDate,
    appStudy,
    dateRange,
    totalPerDay,
    totalsData,
  } = data;

  const themeData = themes[theme];

  return (
    <Document data-testid="study-drug-intake-report-report">
      <Page size="A4" style={generalStyle.page}>
        {Array.apply(
          null,
          Array(Math.ceil(totalPerDay.length / ITEMS_PER_PAGE))
        )
          .map((x, i) => i + 1)
          .map((page) => (
            <View
              break={page !== 1}
              key={`key_${page}`}
              style={{
                flex: 1,
              }}
            >
              <View>
                <BackgroundBlocks {...{ themeData }} />
                <LogoBlock {...{ themeData }} />
              </View>
              <Body {...{ themeData }} title="STUDY DRUG INTAKE">
                <BodyHeader {...{ themeData }}>
                  <BodyHeaderItem
                    title="Protocol Number:"
                    subTitle={appStudy?.toUpperCase()}
                  />
                  <BodyHeaderItem
                    title="Participant ID:"
                    subTitle={participantID}
                  />
                </BodyHeader>
                <Table headers={headersTable1} {...{ themeData }}>
                  <View>
                    <Text
                      style={{
                        ...generalStyle.semiBold,
                        ...reportStyle.text,
                      }}
                    >
                      {dateRange}
                    </Text>
                    <Text
                      style={{
                        ...reportStyle.text,
                        ...generalStyle.semiBold,
                      }}
                    >
                      {totalsData.completedDays} day(s)
                    </Text>
                    <Text
                      style={{
                        ...reportStyle.text,
                        ...generalStyle.semiBold,
                      }}
                    >
                      {totalsData.sickDays} day(s)
                    </Text>
                    <Text
                      style={{
                        ...reportStyle.text,
                        ...generalStyle.semiBold,
                      }}
                    >
                      {Number(totalsData.average).toFixed(decimalPlaces)} ml
                    </Text>
                  </View>
                </Table>
                <Table
                  headers={headersTable2}
                  {...{ themeData }}
                  rowHighlight={true}
                >
                  {totalPerDay
                    .slice((page - 1) * ITEMS_PER_PAGE, page * ITEMS_PER_PAGE)
                    .map((row, index) => (
                      <View key={index} highlight={row.dayTotal}>
                        <Text
                          style={{
                            ...generalStyle.bold,
                            ...reportStyle.text,
                          }}
                        >
                          {row.hour || row.date}
                        </Text>
                        <Text
                          style={{
                            ...reportStyle.text,
                            ...generalStyle.semiBold,
                          }}
                        >
                          {row.dayTotal ? row.completed : "-"}
                        </Text>
                        <Text
                          style={{
                            ...reportStyle.text,
                          }}
                        >
                          {row.dayTotal ? row.sickDay : "-"}
                        </Text>
                        <Text
                          style={{
                            ...reportStyle.text,
                          }}
                        >
                          {Number(row.studyDrugQty).toFixed(decimalPlaces)} ml
                        </Text>
                      </View>
                    ))}
                </Table>
                <Text style={reportStyle.note}>
                  * Study Drug Daily Average (average of the daily totals over
                  the selected dates)
                </Text>
              </Body>
            </View>
          ))}
        <FooterBlock fixed {...{ themeData }} {...{ generatedDate }} />
      </Page>
    </Document>
  );
};

export default StudyDrugIntakeReport;
